import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function WeaponBrandRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/weapon-brand', component: Index, isProtected: true, permissions: ['weapon_brand_index']},
    {path: '/weapon-brand/create', component: Create, isProtected: true, permissions: ['weapon_brand_create']},
    {path: '/weapon-brand/edit/:id', component: Edit, isProtected: true, permissions: ['weapon_brand_edit']},

  ];

  return routes;
}
